{
  "appName": "VynaEMR",
  "appTagline": "Hồ sơ Y tế Điện tử Ưu tiên Châu Á - Thái Bình Dương",
  "developedByLabel": "Được phát triển bởi",
  "loading": "Đang tải...",
  "save": "Lưu",
  "cancel": "Hủy",
  "delete": "Xóa",
  "edit": "Sửa",
  "create": "Tạo mới",
  "search": "Tìm kiếm",
  "filter": "Lọc",
  "actions": "Thao tác",
  "confirm": "Xác nhận",
  "back": "Quay lại",
  "next": "Tiếp theo",
  "previous": "Trước đó",
  "submit": "Gửi",
  "reset": "Đặt lại",
  "close": "Đóng",
  "yes": "Có",
  "no": "Không",
  "ok": "OK",
  "error": "Lỗi",
  "success": "Thành công",
  "warning": "Cảnh báo",
  "info": "Thông tin",
  "validation": {
    "required": "Trường này là bắt buộc",
    "invalidEmail": "Địa chỉ email không hợp lệ",
    "invalidPhone": "Số điện thoại không hợp lệ",
    "invalidDate": "Ngày không hợp lệ",
    "minLength": "Tối thiểu {{min}} ký tự",
    "maxLength": "Tối đa {{max}} ký tự",
    "passwordMismatch": "Mật khẩu không khớp"
  },
  "form": {
    "fieldRequired": "Vui lòng nhập {{field}}",
    "selectOption": "Vui lòng chọn một mục",
    "discardConfirm": "Hủy bỏ các thay đổi chưa lưu?",
    "unsavedChanges": "Bạn có các thay đổi chưa lưu",
    "mustBeNonNegativeInteger": "{{field}} phải là số nguyên (0 trở lên)",
    "mustBeNonNegativeNumber": "{{field}} phải là số (0 trở lên)"
  },
  "unsavedChanges": {
    "title": "Thay đổi chưa lưu",
    "body": "Bạn có các thay đổi chưa lưu. Bạn có chắc muốn rời trang này không? Các thay đổi sẽ bị mất.",
    "stay": "Ở lại",
    "leave": "Rời đi"
  },
  "messages": {
    "saveSuccess": "Đã lưu thay đổi thành công",
    "saveError": "Không thể lưu thay đổi",
    "deleteConfirm": "Bạn có chắc chắn muốn xóa mục này không?",
    "deleteSuccess": "Đã xóa mục thành công",
    "deleteError": "Không thể xóa mục",
    "networkError": "Lỗi mạng. Vui lòng kiểm tra kết nối của bạn.",
    "serverError": "Lỗi máy chủ. Vui lòng thử lại sau.",
    "unauthorized": "Bạn không có quyền thực hiện thao tác này."
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM, YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "Đây là bản demo VynaEMR — không nhập thông tin bệnh nhân thật (PHI)."
  },
  "network": {
    "offline": "Bạn đang ngoại tuyến. Dữ liệu lâm sàng có thể không được lưu."
  },
  "permissionDenied": {
    "title": "Truy cập bị từ chối",
    "body": "Bạn không có quyền {{action}}.",
    "genericBody": "Bạn không có quyền xem tài nguyên này.",
    "requiredPermission": "Quyền yêu cầu: {{name}}",
    "contactAdmin": "Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ với quản trị viên hệ thống.",
    "requiresPermissionCode": "Yêu cầu quyền: {{code}}",
    "requiresLabel": "Yêu cầu {{label}}",
    "requiresLabelWithRoles": "Yêu cầu {{label}} (do: {{roles}} nắm giữ)",
    "insufficient": "Không đủ quyền"
  },
  "skipToContent": "Đi tới nội dung",
  "openMenu": "Mở menu",
  "topBar": {
    "searchPlaceholder": "Tìm bệnh nhân (MRN, tên, ID)...",
    "recentPatients": "Bệnh nhân gần đây",
    "searching": "Đang tìm...",
    "noPatientsFound": "Không tìm thấy bệnh nhân. Nhấn Enter để tìm.",
    "notifications": "Thông báo",
    "selectFacility": "Chọn cơ sở y tế",
    "allFacilities": "Tất cả cơ sở",
    "facilityLabel": "Cơ sở {{id}}",
    "activeDepartment": "Đang làm việc tại",
    "selectDepartment": "Chọn khoa làm việc",
    "noDepartmentSelected": "Chọn khoa",
    "departmentLabel": "Khoa {{id}}",
    "departmentSwitchFailed": "Không thể chuyển"
  },
  "theme": {
    "toggle": "Đổi giao diện",
    "light": "Sáng",
    "dark": "Tối",
    "system": "Hệ thống",
    "current": "Giao diện: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "Đang hoạt động",
  "footerHealthIssue": "Sự cố kết nối",
  "dobLabel": "Ngày sinh {{date}}",
  "pagination": {
    "previous": "Trước",
    "next": "Tiếp",
    "pageOf": "Trang {{current}} / {{total}}",
    "showing": "Hiển thị {{from}} đến {{to}} trên {{total}}",
    "loadMore": "Tải thêm"
  },
  "table": {
    "empty": "Không có dữ liệu",
    "loading": "Đang tải..."
  },
  "cdsAlert": {
    "severity": {
      "info": "Thông tin",
      "warning": "Cảnh báo",
      "critical": "Nghiêm trọng"
    },
    "overridden": "Đã ghi đè",
    "acknowledged": "Đã xác nhận",
    "justificationPlaceholder": "Nhập lý do biện minh...",
    "submit": "Gửi",
    "acknowledge": "Xác nhận",
    "override": "Ghi đè",
    "regionAria": "Cảnh báo hỗ trợ quyết định lâm sàng (CDS)",
    "acknowledgeFailed": "Không thể ghi nhận xác nhận — chưa được lưu. Vui lòng thử lại.",
    "overrideFailed": "Không thể ghi nhận ghi đè — chưa được lưu. Vui lòng thử lại.",
    "addressedCount_one": "Đã xử lý {{count}}",
    "addressedCount_other": "Đã xử lý {{count}}"
  },
  "components": {
    "printButton": {
      "defaultLabel": "In"
    },
    "codeSearch": {
      "searchPlaceholder": "Tìm mã...",
      "clearAriaLabel": "Xóa lựa chọn",
      "noCodesFound": "Không tìm thấy mã"
    },
    "demographicPicker": {
      "addPlaceholder": "Thêm…",
      "loading": "Đang tải…",
      "noneRecorded": "Chưa ghi nhận",
      "removeAriaLabel": "Xóa {{value}}",
      "unavailable": "Không có danh sách giá trị",
      "unavailableHint": "Không thể tải danh sách giá trị. Các giá trị hiện có giữ nguyên và vẫn sẽ được lưu.",
      "uncodedBadge": "chưa mã hóa",
      "uncodedTitle": "Được ghi nhận trước khi có giá trị mã hóa. Có thể xóa, nhưng không thể thêm lại."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "Truy cập bị từ chối",
      "httpStatus": "HTTP 403",
      "body": "Bạn không có quyền xem trang này.",
      "attemptedLabel": "Đã thử truy cập:",
      "requiredPermissionLabel": "Quyền yêu cầu:",
      "typicallyHeldByLabel": "Thường được nắm giữ bởi:",
      "signedInAs": "Đã đăng nhập với tên",
      "contactAdminHelp": "Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ với quản trị viên hệ thống hoặc trưởng khoa để yêu cầu vai trò cần thiết.",
      "goBack": "Quay lại",
      "dashboard": "Bảng điều khiển",
      "contact": "Liên hệ"
    },
    "notificationInbox": {
      "title": "Thông báo",
      "markAllRead": "Đánh dấu tất cả là đã đọc",
      "loading": "Đang tải thông báo…",
      "errorState": "Không tải được thông báo.",
      "emptyState": "Không tìm thấy thông báo.",
      "ariaFilterStatus": "Lọc theo trạng thái",
      "ariaFilterPriority": "Lọc theo mức ưu tiên",
      "ariaFilterType": "Lọc theo loại",
      "filterStatus": {
        "all": "Tất cả",
        "unread": "Chưa đọc",
        "read": "Đã đọc"
      },
      "filterPriority": {
        "allLabel": "Tất cả mức ưu tiên",
        "critical": "Khẩn cấp",
        "high": "Cao",
        "normal": "Bình thường",
        "low": "Thấp"
      },
      "filterType": {
        "allLabel": "Tất cả các loại"
      },
      "notificationType": {
        "criticalResult": "Kết quả khẩn cấp",
        "orderUpdate": "Cập nhật chỉ định",
        "appointmentReminder": "Nhắc lịch hẹn",
        "systemAlert": "Thông báo hệ thống",
        "cdsAlert": "Cảnh báo hỗ trợ quyết định lâm sàng",
        "result": "Kết quả xét nghiệm",
        "handoffAssigned": "Bàn giao"
      },
      "toasts": {
        "allMarkedRead": "Tất cả thông báo đã được đánh dấu là đã đọc",
        "markAllReadFailed": "Không thể đánh dấu tất cả thông báo là đã đọc",
        "markReadFailed": "Không thể đánh dấu thông báo là đã đọc"
      }
    },
    "entityResolver": {
      "invalidId": "Liên kết không hợp lệ.",
      "notFound": "Không tìm thấy, hoặc bạn không có quyền truy cập."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "Không có cập nhật trực tiếp",
    "body": "Kết quả và cảnh báo mới sẽ không tự động đến cho đến khi kết nối được khôi phục.",
    "authBody": "Phiên của bạn đã hết hạn. Vui lòng đăng nhập lại để khôi phục cập nhật trực tiếp.",
    "retry": "Thử lại",
    "login": "Đăng nhập"
  }
}
